<template>
  <div>
    <h1 class="mt-3 mb-0">Success !</h1>
    <p class="text-dark mb-0">Reset password link will be in your email shortly</p>
    <p class="text-dark mb-0">please click the link and put new password</p>
    <div class="d-inline-block w-100">
          <button type="button" @click="fnLogin()" class="btn btn-primary mt-3">Back to Home</button>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        fnLogin(){
            this.$router.push({name: 'auth.sign-in'});
        }
        
    }
}
</script>